'use strict';

const { fetchHomepageSliderBids } = require('./adformBidsRequest');
const adformConstants = require('./adformConstants');
const {
    addAdformPlaceholder,
    adjustSlideTrackingIndexes,
    initAdformRequestLifecycle
} = require('./common/adformHelperFunctions');
const { buildBidSlides, insertBidSlides, revealSlider } = require('./helpers/adformSliderSlideHelpers');

// same identifier the aspect-ratio CSS already keys off (carousel.scss) - not adform-specific,
// used here only as a fallback in case the isml:homepageMainSlider:ready dispatch is ever lost
const HOMEPAGE_MAIN_SLIDER_SELECTOR = '.homepage-main-slider';

let hasTriggeredFetch = false;

/**
 * Applies the loading placeholder and kicks off the bid fetch for the given slider, once.
 * @param {Element} slider - slider element
 */
function triggerFetch(slider) {
    if (hasTriggeredFetch) {
        return;
    }
    hasTriggeredFetch = true;

    addAdformPlaceholder(slider);
    fetchHomepageSliderBids({ slider: slider });
}

/**
 * Init events that make adform request to get data to create banner ads for the homepage main slider.
 */
function initMakeRequestEvents() {
    document.addEventListener('isml:homepageMainSlider:ready', (e) => {
        const slider = e.detail?.slider;
        if (!slider) {
            return;
        }

        triggerFetch(slider);
    });

    // fallback: if the ready event is ever lost (e.g. the hook-rendered dispatch failed to render for this
    // page load), locate the slider by its identifier once the page has fully parsed instead of never fetching
    document.addEventListener('DOMContentLoaded', () => {
        const slider = document.querySelector(HOMEPAGE_MAIN_SLIDER_SELECTOR);
        if (!slider) {
            return;
        }

        triggerFetch(slider);
    }, { once: true });
}

/**
 * Init events that wait for adform response to get processed:
 * - case bids exist => insert ad slides, adjust tracking indexes, reveal slider
 * - case no bids => just reveal slider (nothing was ever reserved, so there's nothing to remove)
 */
function initResponseHandlingEvents() {
    document.addEventListener(adformConstants.BIDS_READY_CUSTOM_EVENT_NAME, function (e) {
        if (e.detail?.containerTypeConfig !== adformConstants.CONTAINER_TYPE_HOMEPAGE_CONFIG) {
            return;
        }

        const slider = e.detail?.additionalEventData?.slider;
        const bids = e.detail?.bids;
        if (!slider || !bids || !bids.length) {
            return;
        }

        const slides = buildBidSlides(bids);
        const isSlideInserted = insertBidSlides(slider, slides);
        if (isSlideInserted) {
            adjustSlideTrackingIndexes(slider);
        }
        revealSlider(slider);
    });

    document.addEventListener(adformConstants.NO_BIDS_CUSTOM_EVENT_NAME, function (e) {
        if (e.detail?.containerTypeConfig !== adformConstants.CONTAINER_TYPE_HOMEPAGE_CONFIG) {
            return;
        }

        const slider = e.detail?.additionalEventData?.slider;
        if (!slider) {
            return;
        }

        revealSlider(slider);
    });
}

module.exports = {
    init: function () {
        initAdformRequestLifecycle(initResponseHandlingEvents, initMakeRequestEvents);
    }
};
